<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardHeader>
          <strong>Προσθήκη υπεργολάβου</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Προσθήκη υπεργολάβου
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
              <CInput label="Ονοματεπώνυμο" addLabelClasses="requiredLabel" type="text" id="name" placeholder="Ονοματεπώνυμο" v-model="name" horizontal></CInput>
              <CTextarea id="activity" addLabelClasses="requiredLabel" label="Δραστηριότητα" placeholder="Δραστηριότητα" v-model="activity" horizontal></CTextarea>
              <CInput label="Τηλέφωνο" type="text" id="phone" placeholder="Τηλέφωνο" v-model="phone" horizontal></CInput>
              <CInput label="Email" type="email" id="email" placeholder="Email" v-model="email" horizontal></CInput>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="12" xl="6">
      <CCard>
        <CCardHeader>
          <strong>Οικονομικά στοιχεία</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput horizontal type="text" addLabelClasses="requiredLabel" label="ΑΦΜ" id="afm" placeholder="ΑΦΜ" v-model="afm"></CInput>
            <CInput horizontal type="text" label="ΔΟΥ" id="doy" placeholder="ΔΟΥ" v-model="doy"></CInput>
            <CInput horizontal type="text" label="Επάγγελμα" id="profession" placeholder="Επάγγελμα" v-model="profession"></CInput>
            <CInput horizontal type="text" label="Ταχυδρομικός Κώδικας" id="tk" placeholder="Ταχυδρομικός Κώδικας" v-model="tk"></CInput>
            <CTextarea
                label="Άλλες Πληροφορίες / Σχόλια"
                placeholder="Άλλες Πληροφορίες / Σχόλια"
                horizontal
                rows="9"
                v-model="notes"
            />
            <CButton color="primary" @click="store()">Δημιουργία</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CreateSubcontractor',
  props: {
    caption: {
      type: String,
      default: 'Create Subcontractor'
    },
  },
  data: () => {
    return {
        name: '',
        phone: '',
        email: '',
        activity: '',
        doy: '',
        afm: '',
        notes: '',
        profession: '',
        tk: '',
        showMessage: false,
        message: '',
        alertIsShown: false,
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/subcontractors'})
    },
    store() {
        let self = this;
        axios.post('/api/subcontractors?token=' + localStorage.getItem("api_token"),
        {
          name: self.name,
          phone: self.phone,
          email: self.email,
          activity: self.activity,
          doy: self.doy,
          afm: self.afm,
          profession: self.profession,
          tk: self.tk,
          notes: self.notes,
        })
        .then(function (response) {
            self.name = '';
            self.phone = '';
            self.email = '';
            self.activity = '';
            self.doy = '';
            self.afm = '';
            self.profession = '';
            self.tk = '';
            self.notes = '';
            self.message = 'Επιτυχής καταχώρηση υπεργολάβου.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: 'login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function(){
  }
}

</script>